import * as React from "react";
import { forwardRef } from "react";
const SvgBagIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M17.1632 8.50002H6.57849C6.32432 8.48965 6.07502 8.57191 5.87694 8.73152C5.67885 8.89112 5.54544 9.11721 5.50149 9.36777L4.00149 19.804C3.99372 19.9473 4.01633 20.0906 4.06784 20.2245C4.11935 20.3584 4.19858 20.4799 4.30036 20.581C4.40213 20.6822 4.52413 20.7606 4.65837 20.8113C4.7926 20.862 4.93603 20.8837 5.07924 20.875H18.6625C18.8057 20.8837 18.9491 20.862 19.0833 20.8113C19.2175 20.7606 19.3394 20.6822 19.4411 20.581C19.5429 20.4799 19.622 20.3583 19.6734 20.2244C19.7249 20.0905 19.7474 19.9472 19.7395 19.804L18.2395 9.36777C18.1956 9.11734 18.0623 8.89136 17.8643 8.73177C17.6664 8.57219 17.4173 8.48984 17.1632 8.50002Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M14.623 6.29275C14.4998 5.64919 14.1566 5.06852 13.6522 4.65022C13.1479 4.23193 12.5137 4.00206 11.8585 4C11.2065 4.00286 10.5756 4.23139 10.073 4.64676C9.57039 5.06212 9.22712 5.6387 9.1015 6.2785",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgBagIcon);
export default ForwardRef;
